import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsBulkActionEnabled = () => {
  const { value: isEnabled } = useFeatureGate('phx_bulk_actions');

  return isEnabled;
};
